import React from 'react'
import { Link } from 'react-router-dom'

function GetInTouch() {
    return (
        <div className="space">
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">Hubungi Kami</span>
                    <h2 className="sec-title">Informasi Kontak Kami</h2>
                </div>
                <div className="row gy-4 justify-content-center">
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid style2">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/location-dot2.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">Alamat Kami</h6>
                                <p className="about-contact-details-text">
                                    Wae Kelambu, Kec. Komodo
                                </p>
                                <p className="about-contact-details-text">Kabupaten Manggarai Barat, Nusa Tenggara Timur</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/call.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">Nomor Telepon</h6>
                                <p className="about-contact-details-text">
                                    <Link to="tel:03852443240">(0385) 2443240</Link>
                                </p>
                                <p className="about-contact-details-text">
                                    Dinas Komunikasi dan Informatika
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/mail.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">Alamat Email</h6>
                                <p className="about-contact-details-text">
                                    <Link to="mailto:diskominfo@manggaraibaratkab.go.id">diskominfo@manggaraibaratkab.go.id</Link>
                                </p>
                                <p className="about-contact-details-text">
                                    Dinas Komunikasi dan Informatika
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default GetInTouch
